import React from 'react';
import { Form } from 'react-bootstrap';

import dayjs from 'dayjs';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarEdit } from '@fortawesome/pro-solid-svg-icons';

import PopoverTrigger from '../../components/PopoverTrigger';
import DashboardDateSelect from './DashboardDateSelect';
import CHARTCOLORS from '../../helpers/chartColors';

const getStyles = (isLoading) => ({
  inputStyle: {
    width: '200px',
    textAlign: 'center',
    marginRight: '10px',
  },
  buttonStyle: {
    fontSize: '26px',
    color: !isLoading ? CHARTCOLORS[1] : CHARTCOLORS[2],
  },
  buttonContainerStyle: {
    display: 'inline-block',
    cursor: 'pointer',
    pointerEvents: !isLoading ? 'auto' : 'none',
  },
});

export default function DashboardDateSelectContainer(props) {
  const { startDate, setStartDate, endDate, setEndDate, isLoading } = props;

  const styles = getStyles(isLoading);
  return (
    <>
      {' '}
      <Form.Label style={{ marginRight: '0.5em' }}>12-month range:</Form.Label>
      <Form.Control
        style={styles.inputStyle}
        size='sm'
        disabled
        value={
          startDate && endDate
            ? dayjs.utc(startDate).format('MMM YYYY') +
              ' - ' +
              dayjs.utc(endDate).format('MMM YYYY')
            : ''
        }
      />
      <div id='dashboard-popover-button' style={styles.buttonContainerStyle}>
        <PopoverTrigger
          rootClose={true}
          popoverTitle={'End Date'}
          popoverContent={
            <DashboardDateSelect
              startDate={startDate}
              setStartDate={setStartDate}
              endDate={endDate}
              setEndDate={setEndDate}
            />
          }
          trigger='click'
          placement='bottom'
        >
          <FontAwesomeIcon
            style={styles.buttonStyle}
            icon={faCalendarEdit}
            id={'dashboard-date-popover'}
          />
        </PopoverTrigger>
      </div>
    </>
  );
}
